function cms(state = {
  CmsContent:null,
  CmsList:[],
  BannerMainList:[],
  BannerFeaturedList:[],
  homePage:[],
  getHomePage:false,
  getCms: false,
  getCmsList: false,
  getMainBannerList: false,
  getFeaturedBannerList: false,
  getBannerClick: false,
  errorCms: false,
  errorCmsList:false,
  errorMainBannerList:false,
  errorFeaturedBannerList:false,
  errorBannerClick:false,
  fetching:false,
  getMainBannerListFetching:false,
  getHomePageFetching:false,
  showAdvisoryExtensionModal:{
    cart: true,
  },
  showAdvisoryModal: {
    cart: true,
    home: true,
    checkout: true
  }
}, action){
  switch (action.type) {
    case 'FETCHING':{
      return{
        ...state,
        fetching: true,
        getCms:false,
        CmsContent:null,
      }
    }
    case 'GET_CMS_FULFILLED':{
      return{
        ...state,
        getCms: true,
        errorCms: false,
        fetching:false,
        CmsContent: action.payload,
      }
    }
    case 'GET_CMS_REJECTED':{
      return{
        ...state,
        getCms: false,
        fetching:false,
        errorCms: true,
      }
    }
    case 'GET_CMS_LIST_REJECTED':{
        return {
          ...state,
          getCmsList: false,
          errorCmsList: action.payload,
        }
      }
      case 'GET_CMS_LIST_FULFILLED':{
        return{
          ...state,
          getCmsList: true,
          CmsList: action.payload,
          errorCmsList:false,
        }
      }
      case 'GET_MAIN_BANNER_LIST_REJECTED':{
        return {
          ...state,
          getMainBannerList: false,
          errorMainBannerList: action.payload,
        }
      }
      case 'GET_MAIN_BANNER_LIST_FULFILLED':{
        return{
          ...state,
          getMainBannerList: true,
          BannerMainList: action.payload,
          errorMainBannerList:false,
          getMainBannerListFetching:false,
        }
      }
      case 'GET_MAIN_BANNER_LIST_FETCHING':{
        return{
          ...state,
          getMainBannerList: false,
          getMainBannerListFetching:true,
        }
      }
      case 'GET_FEATURED_BANNER_LIST_REJECTED':{
        return {
          ...state,
          getFeaturedBannerList: false,
          errorFeaturedBannerList: action.payload,
        }
      }
      case 'GET_FEATURED_BANNER_LIST_FULFILLED':{
        return{
          ...state,
          getFeaturedBannerList: true,
          BannerFeaturedList: action.payload,
          errorFeaturedBannerList:false,
          getFeaturedBannerListFetching:false,
        }
      }
      case 'PUT_BANNER_CLICK_REJECTED':{
        return {
          ...state,
          getBannerClick: false,
          errorBannerClick: action.payload,
        }
      }
      case 'PUT_BANNER_CLICK_FULFILLED':{
        return{
          ...state,
          getBannerClick: action.payload,
          errorBannerClick:false,
        }
      }
      case 'GET_HOMEPAGE_BLOCKS_FULFILLED':{
        return {
          ...state,
          getHomePage: true,
          homePage: action.payload,
          getHomePageFetching:false,
        }
      }
      case 'GET_HOMEPAGE_BLOCKS_FETCHING':{
        return {
          ...state,
          getHomePage: false,
          getHomePageFetching:true,
        }
      }
      case 'GET_HOMEPAGE_BLOCKS_REJECTED':{
        return{
          ...state,
          getHomePage: false,
          homePage: action.payload,
        }
      }
      case 'GET_MODAL__BLOCKS_FETCHING':{
        return {
          ...state,
          getModal: false,
        }
      }
      case 'GET_MODAL_BLOCKS_FULFILLED':{
        return {
          ...state,
          getModal: true,
          modalContent: action.payload,
        }
      }
      case 'GET_MODAL_EXTENSION_FULFILLED':{
        return {
          ...state,
          getModal: true,
          modalExtensionContent: action.payload,
        }
      }
      case 'GET_MODAL__BLOCKS_REJECTED':{
        return{
          ...state,
          getModal: false,
          modalContent: action.payload,
          modalExtensionContent: action.payload,
        }
      }
      case 'RESET_CMS':{
        return{
          ...state,
          getHomePage: false,
          getCms:false,
          getCmsList:false,
          getBannerClick:false,
          getFeaturedBannerList:false,
          getMainBannerList:false,
        }
      }

      case 'HIDE_ADVISORY_MODAL': {
        return {
          ...state,
          getModal: false,
          showAdvisoryModal: {
            ...state.showAdvisoryModal,
            [action.page]: false
          }
        }
      }

      case 'HIDE_ADVISORY_EXTENSION_MODAL': {
        return {
          ...state,
          getModal: false,
          showAdvisoryExtensionModal: {
            ...state.showAdvisoryExtensionModal,
            [action.page]: false
          }
        }
      }
      case 'GET_CART_BANNER_FULFILLED': {
        return {
          ...state,
          cartBanner: true,
          getCartBanner: action.payload.data.data
        }
      }
      case 'GET_CART_BANNER_REJECTED': {
        return {
          ...state,
          cartBanner: false,
          getCartBanner: action.payload,
        }
      }
      default:break
   }
   return state;
}
export default cms;



/** WEBPACK FOOTER **
 ** ./src/reducers/cms.js
 **/